export default __webpack_public_path__ + "static/media/locationimage.85f4d56d.png";